import Axios from "axios";
import Config from "@/config/index.js";
// eslint-disable-next-line no-unused-vars
import { getToken } from "@/utils/common.js";
import { Toast } from "vant";
const service = Axios.create({
  baseURL: Config.apiUrl + "/" + Config.apiPrefix,
  headers: {
    Accept: "*/*"
  },
  timeout: Config.timeout
});

service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;
// let LoadingInstance = null;

service.interceptors.request.use(
  config => {
    if (config.showLoading) {
      //加载提示
      window.LoadingInstance = Toast.loading({
        mask: true,
        message: "加载中..."
      });
    }
    config.headers["businessSource"] = Config.businessSource;
    config.headers["terminalPlatform"] = Config.terminalPlatform;
    config.headers["requestId"] = Config.requestId;
    config.headers["loginType"] = Config.loginType; //重要，否则使用登陆系统登陆的 token 没法使用
    let token = getToken();
    if (token && !config.noToken) {
      //如果有 token 并且没有在配置里添加 noToken:true 才会带上token
      config.headers["Authorization"] = token;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
// response interceptor
service.interceptors.response.use(response => {
  const res = response.data;
  return res;
});
export default service;
